import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { ModalError, ModalSuccess } from "components";
import { hardBaseUrl } from "../../../../../services/urlConstant";
import PaymentComposerInvoice from "../Components/PaymentComposerInvoice";
import { getErrors } from "utils";

function ComposerInvoiceForm() {
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);

  const handlSubmitData = async payload => {
    try {
      setLoadingPage(true);
      await axios.post(`${hardBaseUrl}/publisher/transaction`, payload, {
        headers,
      });
      ModalSuccess("Payment Composer Invoice has been created").then(() =>
        history.goBack()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  return (
    <PaymentComposerInvoice
      pageTitle="Create Payment Composer Invoice"
      pageSubTitle="Create your transaction here"
      loadingPage={loadingPage}
      onSubmitPayload={handlSubmitData}
    />
  );
}

export default ComposerInvoiceForm;
